<script>
	export let name;
</script>

<main>
	<h1>
		Period. kommer snart...
	</h1>
	<img src="images/Tampong.svg" alt="Tamong.svg" />
</main>


<style>
	main {
		margin: auto;
	}

	@import url('https://fonts.googleapis.com/css2?family=Lato:wght@900&display=swap');
	/* henter ikke inn mac versjonen av font */
	h1 {
		font-family: 'Lato', sans-serif;
		font-weight: 900;
		font-style: normal;
		font-size: 6em;
		color: #3119C5;
		height: 100px;
		text-align: center;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}

	img {
  		padding-top: 200px;
  		padding-left: 200px;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
